var map = {
	"./AcquaPanna.svg": 1988,
	"./Belaire.svg": 6729,
	"./Bols.svg": 8633,
	"./Bulldog.svg": 2322,
	"./Delirium.svg": 5102,
	"./Espolon.svg": 3423,
	"./Glenfiddich.svg": 6540,
	"./GrandMarnier.svg": 8771,
	"./Grolsch.svg": 4289,
	"./Jagermeister.svg": 8789,
	"./Licor43.svg": 9705,
	"./Margherita.svg": 7859,
	"./Montelobos.svg": 9139,
	"./Ocean.svg": 3367,
	"./Peroni.svg": 6624,
	"./Perrier.svg": 9402,
	"./PuertodeIndias.svg": 2693,
	"./SPellegrino.svg": 6321,
	"./Titos.svg": 9612,
	"./Torresella.svg": 9870
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 655;